<template>
  <v-dialog
      v-model="dialog"
      width="840"
  >
    <v-card class="tw-px-2">
      <card-title>Choose the type of claim you wish to initiate :</card-title>

      <div class="tw-w-full tw-flex tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-gap-0 lg:tw-gap-2 tw-py-5">
        <v-card class="tw-h-56 tw-bg-cover tw-bg-no-repeat tw-mt-4" style="background-image: url(/images/claims/claim2.jpg);">
          <a href="https://www.apainsurance.org/claim_report_accident.php" target="_blank" rel="noopener" class="overlay tw-flex tw-items-center tw-flex-col tw-text-center">
            <h3 class="tw-text-white tw-mt-20 tw-text-xl tw-font-bold">Accident</h3>
            <p class="tw-text-white tw-text-sm tw-mt-4">Covers third party bodily injury and property damage arising out of a vehicle accident.</p>
          </a>
        </v-card>
        <v-card class="tw-h-56 tw-bg-cover tw-bg-no-repeat tw-mt-4" style="background-image: url(/images/claims/claim3.jpg);">
          <a href="https://www.apainsurance.org/claim_report_windscreen.php" rel="noopener" target="_blank" class="overlay tw-flex tw-items-center tw-flex-col tw-text-center">
            <h3 class="tw-text-white tw-mt-20 tw-text-xl tw-font-bold">Windscreen</h3>
            <p class="tw-text-white tw-text-sm tw-mt-4">Cover extends to cover windscreen damage.</p>
          </a>
        </v-card>
        <v-card class="tw-h-56 tw-bg-cover tw-bg-no-repeat tw-mt-4" style="background-image: url(/images/claims/claim4.jpg);">
          <a href="https://www.apainsurance.org/claim_report_theft.php" target="_blank" rel="noopener" class="overlay tw-flex tw-items-center tw-flex-col tw-text-center">
            <h3 class="tw-text-white tw-mt-20 tw-text-xl tw-font-bold">Theft</h3>
            <p class="tw-text-white tw-text-sm tw-mt-4"> This claim Cover theft of vehicle.</p>
          </a>
        </v-card>
      </div>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="error"
            text
            @click="dialog = false"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CardTitle from '@/components/shared/CardTitle';

export default {
  name: 'ClaimsModal',
  components: { CardTitle },
  data() {
    return {
      dialog: false,
    };
  },
  mounted() {
    this.$root.$on('modal-opened-claims', () => {
      this.dialog = true;
    });
  },
};
</script>
